<template>
  <TransitionRoot as="template" :show="modalOpen">
    <Dialog as="div" class="relative z-50" @close="closeModal">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
            >
              <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  @click="closeModal"
                >
                  <span class="sr-only">{{ $t(`Close`) }}</span>
                  <icon name="heroicons:x-mark" class="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div class="sm:flex sm:items-start">
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <!-- <DialogTitle as="h2" class="text-xl font-bold leading-6 text-gray-900">Help</DialogTitle> -->
                  <div v-if="message !== null && message !== ''" v-html="message" class="mt-2 text-xl px-2"></div>
                  <div class="mt-2 text-xl" v-else>
                    {{ $t(`This Zip/Postal Code is not currently accepting new applications.`) }}<br /><br />

                    {{
                      $t(
                        `If you previously began an application in this Zip/Postal Code that you did not fully complete
                        and submit,
                        please check back later or reach out to your local Salvation Army.`
                      )
                    }}<br /><br />

                    {{
                      $t(
                        `If you have already submitted a completed application within this Zip/Postal Code and would like
                        to review the status, please continue.`
                      )
                    }}
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button type="submit" class="btn-primary" :disabled="disableBtn" @click="continueAr">
                  <span>{{ $t(`OK`) }}</span>
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

const emit = defineEmits(['update:modalOpen', 'update:continue']);
const props = defineProps<{
  modalOpen: boolean;
  message: string;
}>();

const closeModal = () => {
  emit('update:modalOpen', false);
};

const disableBtn = ref(false);
const continueAr = () => {
  disableBtn.value = true;
  emit('update:continue', false);
  closeModal();
  disableBtn.value = false;
};
</script>
